import { ChangeEvent, useEffect, useState } from 'react';

const useItemSelection = (itemIds: string[]) => {
  const [selectedItemIds, setSelectedItemIds] = useState<string[]>([]);
  const [lastToggledItemId, setLastToggledItemId] = useState<string>();

  const handleSelectItemIds = (ids: string[], order: 'asc' | 'desc' = 'desc') => {
    setLastToggledItemId(order === 'asc' ? ids[0] : ids[ids.length - 1]);
    setSelectedItemIds(prev => [...new Set([...prev, ...ids])]);
  };
  const handleDeselectItemIds = (ids: string[], order: 'asc' | 'desc' = 'desc') => {
    setLastToggledItemId(order === 'asc' ? ids[0] : ids[ids.length - 1]);
    setSelectedItemIds(prev => prev.filter(id => !ids.includes(id)));
  };

  useEffect(() => {
    const movedItemIds = selectedItemIds.filter(itemId => !itemIds.includes(itemId));
    if (movedItemIds.length > 0) {
      handleDeselectItemIds(movedItemIds);
    }
  }, [itemIds, selectedItemIds]);

  const handleCheckHeader = (event: ChangeEvent<HTMLInputElement>, checkedItemIds: string[]) => {
    if (event.currentTarget.checked) {
      handleSelectItemIds(checkedItemIds);
    } else {
      handleDeselectItemIds(checkedItemIds);
    }
  };

  const handleCheckItem = (event: ChangeEvent<HTMLInputElement>, checkedItemId: string) => {
    const { checked } = event.currentTarget;
    if ((event.nativeEvent as unknown as { shiftKey: boolean }).shiftKey) {
      const lastIndex = itemIds.findIndex(id => id === lastToggledItemId);
      const clickIndex = itemIds.findIndex(id => id === checkedItemId);
      const order = clickIndex > lastIndex ? 'desc' : 'asc';
      const itemIdsToToggle =
        order === 'desc' ? itemIds.slice(lastIndex, clickIndex + 1) : itemIds.slice(clickIndex, lastIndex + 1);
      if (checked) {
        handleSelectItemIds(itemIdsToToggle, order);
      } else {
        handleDeselectItemIds(itemIdsToToggle, order);
      }
    } else {
      if (checked) {
        handleSelectItemIds([checkedItemId]);
      } else {
        handleDeselectItemIds([checkedItemId]);
      }
    }
  };

  return { selectedItemIds, handleSelectItemIds, handleDeselectItemIds, handleCheckHeader, handleCheckItem };
};

export default useItemSelection;
